import React, { useContext, useEffect, useState } from 'react';
import {
  DataGrid,
  GridActionsCellItem,
} from '@mui/x-data-grid';
import {
  Edit,
  Delete,
  PauseCircle,
  PlayCircle,
} from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import Header from "../Header.js"
import axios from 'axios';
import AddTaskDialog from './AddTaskDialog.jsx';
import { updateRows } from '../CommonFunctions.js';
import CommonComponents from '../CommonComponents.js';
import DeleteConfirmation from '../DeleteConfirmation.jsx';
import { Grid } from 'rsuite';



export default function AdminTasksTable() {
    const [tasks, setTasks] = useState([]);
    const [showTaskModal, setShowTaskModal] = useState(false);
    const [currentTask, setCurrentTask] = useState(null);
    const {displayNotificationMessage}=useContext(CommonComponents);
    const [showDeleteModal,setShowDeleteModal] = useState(false);


    useEffect(() => {
        getAllTasks();
        }, []);

    useEffect(()=>{
        if(showTaskModal === false){
            setCurrentTask(null)
        }

    }, [showTaskModal]);
const url=process.env.REACT_APP_SERVER_URL;

  const handleEdit = (id) => console.log('Edit', id);
  
  const handleDelete = async (id) => {
  try {
    const taskToUpdate = { ...currentTask, isActive: false };

    // Soft delete = update isActive
    const response = await axios.patch(`${url}/tasks/${id}`, taskToUpdate);
    if (response && response.data) {
      // Remove from table using updateRows (mode: delete)
      updateRowsById({}, "delete", id);
      displayNotificationMessage("info", "Task removed from view");
    }
  } catch (error) {
    console.log(error);
  }
};

  const getAllTasks = async()=>{
    try{
        const response = await axios.get(`${url}/tasks`);
        if(response && response.data){
            console.log(response.data)
            setTasks(response.data);
        }

    }catch(error){
        console.log(error);
    }
  }
  function updateRowsById(tempJson, mode, id) {
    setTasks((prevs) => updateRows(prevs, mode, id, tempJson));
  }

  const editTask = async(taskJson) =>{
    try{
        const id = taskJson.id;
        const response = await axios.patch(`${url}/tasks/${id}`, taskJson);
        if(response){
            updateRowsById(taskJson, "edit", id);
        displayNotificationMessage("success","Updated Task - "+ taskJson.title);


        }

    }catch(error){
        console.log(error);
    }
  }
  const handleToggleStatus = (id, status, taskJson) =>{
    let tempJson = taskJson;
    tempJson["isActive"] = status ? false : true;
    editTask(tempJson);

    console.log(status ? 'Suspend' : 'Activate', id);

  }
  const createEditTask = async(taskJson) =>{
    if(taskJson.id){
      editTask(taskJson);
    }
    else{
      saveTask(taskJson);
    }
  }
  const saveTask = async(taskJson)=>{
    try{
        const response = await axios.post(`${url}/tasks`,taskJson);
        if(response && response.data){
            updateRowsById(response.data, "create", null);
            console.log(response.data);
            displayNotificationMessage("success","Added Task - "+ taskJson.title);

            // setTaskLogs()
        }

    }
    catch(error){
        console.log(error);
    }
  }

  const columns = [
    {
      field: 'title',
      headerName: 'Title',
      width: 240,
    },
    {
      field: 'assigned_name',
      headerName: 'Assigned To',
      width: 150,
    },
    {
      field: 'frequency',
      headerName: 'Frequency',
      width: 150,
    },
    {
      field: 'description',
      headerName: 'Description',
      width: 360,
    },
    {
      field: 'actions',
      type: 'actions',
      width: 150,
      headerName: 'Actions',
      getActions: (params) => [
        <GridActionsCellItem
          icon={<Edit />}
          label="Edit"
          onClick={() => {
            setCurrentTask(params.row)
            setShowTaskModal(true)
            handleEdit(params.id)}}
        />,
        <GridActionsCellItem
          icon={<Delete color="error" />}
          label="Delete"
          onClick={() => {
            setCurrentTask(params.row);
            setShowDeleteModal(true);
        }}
        />,
      ],
    },
  ];

  return (
    <>
    <Header/>
    <br></br>
        <Button variant="contained" onClick={(e)=>setShowTaskModal(true)}
        sx={{marginLeft:"70%"}}
          >ADD TASK</Button>
    <br></br>
    

    <Box
  sx={{
    height: 500,
    width: '80%',
    mx: "10%", // asdds horizontal (left and right) margin
    '& .active-row': {
      borderLeft: '4px solid green',
    },
  }}
>
      <DataGrid
        rows={tasks}
        columns={columns}
        getRowClassName={(params) =>
          params.row.isActive ? 'active-row' : ''
        }
        disableRowSelectionOnClick
        sx={{
          '& .MuiDataGrid-cell': {
            py: 1,
          },
        }}
      />
    </Box>
    {showTaskModal && <AddTaskDialog showTaskModal={showTaskModal} 
    currentTask={currentTask}
        setShowTaskModal={setShowTaskModal} 
        saveTask={createEditTask}/>}

{showDeleteModal && <DeleteConfirmation showDeleteModal={showDeleteModal} 
      setShowDeleteModal={setShowDeleteModal} tableName="task" id={currentTask.id} 
      onConfirmDelete={handleDelete} />} 
    </>
  );
}
